<template>
  <div class="section-container">
    <div class="section-top">
      <div class="flex items-center">
        <p class="section-title mr-3">{{ title }}</p>
        <sf-icon @click="openModal" size="lg" :icon="['fas', 'info-circle']" :style="{ cursor: 'pointer', marginTop: '-3px' }" />
      </div>
      <p class="section-number">{{ step }}/{{ totalSteps }}</p>
    </div>
    <div class="section-bottom">
      <div class="flex mb-6" v-html="cardContent"></div>

      <ul>
        <li
          v-for="option in filteredOptions"
          :key="option.id"
          @click="addToSelection(option)"
          class="list-select-item"
          :class="{ 'selected-list-select-item': isSelected(option) }"
        >
          <p>
            {{ option.variationName || option.name || '' }}
            <span class="text-gray-600 text-sm pr-2" v-if="option.id == 5110 || option.id == 5112">(Nur mit Tahoma Box möglich)</span>
            <span class="text-gray-600 text-sm pr-2" v-if="option.id == 5116">(Mehrkanal-Fernbedienung oder Tahoma Box benötigt)</span>
          </p>
          <p class="font-bold bg-yellow-300 py-1 px-2 min-w-[128px] text-right">
            <span class="mr-1">+</span>{{ optionPrice(option) | formatPrice }} €
          </p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { fetchCategoryContent } from "./Helpers";

export default {
  name: "Extras",
  props: ["category", "step", "totalSteps"],

  data() {
    return {
      modalContent: "",
      title: "Zubehör",
      cardContent: "",
    };
  },

  async created() {
    let { modalContent, title, cardContent } = await this.fetchCategoryContent(this.category, this.$setPreview);
    this.modalContent = modalContent;
    if (title) this.title = title;
    if (cardContent) this.cardContent = cardContent;
  },

  computed: {
    ...mapState("extras/", {
      options: (state) => state.options,
      selection: (state) => state.selection,
    }),

    filteredOptions() {
      let options = this.options.filter(option => {
        // Filter out the options that are only available if Motor IO is selected:
        // Schwingungssensor, Tahoma Box, Sonnenwächter, Temperatursensor & Heizstrahler IO
        if (option.id == 5106 && !this.hasMotorIO) return false;
        if (option.id == 5108 && !this.hasMotorIO) return false;
        if (option.id == 5110 && !this.hasMotorIO) return false;
        if (option.id == 5112 && !this.hasMotorIO) return false;
        if (option.id == 5116 && !this.hasMotorIO) return false;
        return true;
      })

      // Filter out KA (Keine Auswahl) variations, which are not supposed to be selectable by the user
      return options.filter(option => !option.number.includes('-KA'));
    },

    hasMotorIO() {
      return this.$store.state.drive?.selection?.id === 4232; // Check if Motor IO is selected
    },
  },

  methods: {
    fetchCategoryContent,

    addToSelection(option) {
      let selection = this.selection;

      if (!selection.includes(option)) {
        selection.push(option);
      } else {
        selection = selection.filter((item) => item !== option);
      }

      this.setSelection(selection);
    },

    ...mapMutations("extras/", {
      setSelection: "setSelection",
    }),

    isSelected(option) {
      return this.selection.includes(option);
    },

    optionPrice(option) {
      if (!option) return 0;
      if (!option.variationSalesPrices) return 0;

      return option.variationSalesPrices[0].price;
    },

    openModal() {
      this.$store.commit("modal/openModal")
      this.$store.dispatch("modal/setBody", this.modalContent);
      this.$store.dispatch("modal/setTitle", this.title);
    },
  },
};
</script>

<style></style>
